import type { Academy, ApiResponse, Club, Organization } from '@court-sync/shared';
import { publicApiGet } from './apiClient';

export type PublicTenantSubdomainResponse = {
  type: 'organization';
  organization: Organization;
  academy?: Academy | null;
  club?: Club | null;
};

export const publicTenantsService = {
  async getBySubdomain(label: string): Promise<ApiResponse<PublicTenantSubdomainResponse>> {
    return publicApiGet<PublicTenantSubdomainResponse>(
      `/public/tenants/subdomain/${encodeURIComponent(label)}`
    );
  },

  async checkSubdomainAvailability(
    label: string,
    options?: { excludeAcademyId?: string; excludeClubId?: string }
  ): Promise<ApiResponse<{ available: boolean; label: string }>> {
    const params = new URLSearchParams();
    if (options?.excludeAcademyId) params.set('excludeAcademyId', options.excludeAcademyId);
    if (options?.excludeClubId) params.set('excludeClubId', options.excludeClubId);
    const qs = params.toString();
    return publicApiGet<{ available: boolean; label: string }>(
      `/public/tenants/subdomain/${encodeURIComponent(label)}/check${qs ? `?${qs}` : ''}`
    );
  },
};
